import {createSlice} from "@reduxjs/toolkit";

export const enterpriseUserInfoSlice = createSlice({
    name: "enterpriseUserInfo",
    initialState: {
        enterpriseInfo: undefined,
    },
    reducers: {
        setGlobalEnterpriseInfo: (state, action) => {
            state.enterpriseInfo = action.payload;
        }
    }
});

export const {
    setGlobalEnterpriseInfo
} = enterpriseUserInfoSlice.actions;

export const selectEnterpriseInfo = (state) => state.enterpriseUserInfo.enterpriseInfo;

export default enterpriseUserInfoSlice.reducer;

